module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 7
 ** module chunks = 0
 **/